import { render, staticRenderFns } from "./tpl-7.vue?vue&type=template&id=818d9aaa&scoped=true"
import script from "./tpl-7.vue?vue&type=script&lang=js"
export * from "./tpl-7.vue?vue&type=script&lang=js"
import style0 from "./tpl-7.vue?vue&type=style&index=0&id=818d9aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818d9aaa",
  null
  
)

export default component.exports